// Dependencies

// axios
import axiosInstance from "./client";
import { handleDataForLogin, handleDataForLogout } from "~/utils";

const register = async (regisData: {
  email: string;
  username: string;
  password: string;
}) => {
  const response = await axiosInstance.post(`/user/register`, regisData);
  return response;
};

const login = async (loginData: { username: string; password: string }) => {
  const response = await axiosInstance.post(`/user/signin`, loginData);
  const refreshToken = response.data?.refreshToken;
  const accessToken = response.data?.accessToken;
  const userData = {
    name: response.data?.username,
  };

  handleDataForLogin(userData, refreshToken, accessToken);

  return response;
};

const emailConfirm = async (activationToken: string) => {
  const response = await axiosInstance.get(
    `/user/email-confirm?token=${activationToken}`
  );

  return response;
};

const getProfile = async () => {
  const response = await axiosInstance.get(`/user/profile`);
  return response;
};

const changePassword = async (passwordData: {
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axiosInstance.patch(
    `/user/change-password`,
    passwordData
  );
  return response;
};

const logout = async () => {
  await axiosInstance.delete(`/user/logout`);

  handleDataForLogout();

  return undefined;
};

const forgotPassword = async (email: string) => {
  const response = await axiosInstance.patch(`user/forget-password`, {
    email,
  });
  return response;
};

const resetPassword = async (resetData: {
  password: string;
  resetToken: string;
}) => {
  const response = await axiosInstance.patch(`/user/reset-password`, {
    password: resetData.password,
    reset_token: resetData.resetToken,
  });
  return response;
};

export {
  register,
  login,
  emailConfirm,
  getProfile,
  changePassword,
  logout,
  forgotPassword,
  resetPassword,
};
